import { Grid, Typography, Box, styled, Avatar } from '../../../../base';

const AVATAR_SIZE = 37;

export const StyledContainer = styled(Grid)(({ theme }) => ({
    paddingBottom: theme.spacing(5),
    width: '100%',
    alignItems: 'flex-start',
    position: 'relative',
    '&:not(:last-child)::before': {
        content: '""',
        position: 'absolute',
        insetInlineStart: AVATAR_SIZE / 2,
        top: AVATAR_SIZE,
        bottom: 0,
        width: 1,
        backgroundColor: theme.palette.divider,
    },
    '&:last-child': {
        paddingBottom: 0,
    },
}));

export const StyledAvatar = styled(Avatar)(() => ({
    height: AVATAR_SIZE,
    width: AVATAR_SIZE,
}));

export const StyledContent = styled(Box)(({ theme }) => ({
    flex: 1,
    marginInlineStart: theme.spacing(1),
    lineHeight: 1.2,
}));

export const StyledDateText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

export const StyledCommentContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    width: '100%',
}));
